import { render } from "./AdminMenuReview.vue?vue&type=template&id=47770176&scoped=true"
import script from "./AdminMenuReview.vue?vue&type=script&lang=js"
export * from "./AdminMenuReview.vue?vue&type=script&lang=js"

import "./AdminMenuReview.vue?vue&type=style&index=0&id=47770176&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47770176"]])

export default __exports__